import React, { useState } from "react";
import AdminChart from "../charts/AdminChart";
import { getRequest } from "../service/index";
import { NotebookIcon } from "lucide-react";
import TodayAbsent from "../components/common/todayAbsent.jsx";
import PendingRequests from "../components/common/pendingTask.jsx";

const AdminDashboard = () => {

  return (
    <div className="grid grid-cols-1 gap-4 p-4 lg:grid-cols-12">
      <div className="col-span-1 lg:col-span-12 bg-white p-4 rounded-md shadow-2xl ">
      <AdminChart />
      </div>
      <div className="col-span-1 lg:col-span-6 bg-white rounded-md shadow-2xl h-auto min-h-80 flex flex-col border border-gray-200">
        <div className="flex justify-between items-center px-2">
          <h3 className="text-md font-semibold text-primary flex items-center gap-2 py-2 px-2">
            <NotebookIcon className="h-4 w-4" /> Today Absent
          </h3>
        </div>
        <hr className=" border-gray-300" />
        <div className="flex-1 max-h-full overflow-y-auto">
          <TodayAbsent />
        </div>
      </div>
      <div className="col-span-1 lg:col-span-6 bg-white rounded-md shadow-2xl h-auto min-h-80 flex flex-col border border-gray-200">
        <div className="flex justify-between items-center px-2">
          <h3 className="text-md font-semibold text-primary flex items-center gap-2 py-2 px-2">
            <NotebookIcon className="h-4 w-4" /> Pending Requests
          </h3>
        </div>
        <hr className=" border-gray-300" />
        <div className="flex-1 max-h-full overflow-y-auto">
          <PendingRequests />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;